import React from 'react';

import isArray from 'lodash/isArray';

import SvgIcon from '@mui/material/SvgIcon';

function createSvgIcon(name, component, options = {}) {
  const { viewBox, fill } = options || {};

  function Component(props, ref) {
    const { sx, ...restProps } = props;

    return (
      <SvgIcon
        ref={ref}
        sx={[{ fill: fill === 'none' ? 'transparent' : fill }, ...(isArray(sx) ? sx : [sx])]}
        {...restProps}
        viewBox={viewBox}
        component={component}
      />
    );
  }


  return React.memo(React.forwardRef(Component));
}

export default createSvgIcon;
